import { FC } from 'react';
import { CustomTooltip } from '@dynamika-shared/ui/Tooltip/CustomTooltip';
import { twMerge } from '@utils/twMerge';

type InstitutionInfoProps = {
  name?: string;
  address?: string;
  enabled?: boolean;
  className?: string;
  classNameText?: string;
};
export const InstitutionInfo: FC<InstitutionInfoProps> = ({
  name,
  address,
  enabled = true,
  className,
  classNameText,
}) => {
  return (
    <div
      className={twMerge('flex items-center gap-[1.2rem] w-full', className)}
    >
      <div className={twMerge('text flex max-w-full flex-col', classNameText)}>
        {name && (
          <CustomTooltip
            label={name}
            className={twMerge(enabled ? 'text-black' : 'text-spanishGray')}
          />
        )}
        {address && (
          <CustomTooltip
            label={address.toUpperCase()}
            className={twMerge('text-1216 mt-[2px] text-spanishGray')}
          />
        )}
      </div>
    </div>
  );
};
